import React from "react";
import { Input, InputNumber, DatePicker, Radio, Button } from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { RawMaterialStock } from "../../../Types";

interface Props {
  formStocks: RawMaterialStock[];
  onAdd: () => void;
  onRemove: (index: number) => void;
  onUpdate: (index: number, key: keyof RawMaterialStock, value: any) => void;
}

export const StockBatchEditor: React.FC<Props> = ({
  formStocks,
  onAdd,
  onRemove,
  onUpdate,
}) => (
  <div>
    <div className="flex justify-between items-center mb-3">
      <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
        Stock Batches
      </span>
      <Button
        type="dashed"
        size="small"
        icon={<PlusOutlined />}
        onClick={onAdd}
      >
        Add Batch
      </Button>
    </div>

    <div className="flex flex-col gap-3">
      {formStocks.map((batch, index) => (
        <div
          key={index}
          className="p-3 bg-gray-50 border border-gray-100 rounded-md relative"
        >
          <div className="flex justify-between items-center mb-2">
            <span className="text-xs font-semibold text-gray-500">
              Batch #{index + 1}
            </span>
            {formStocks.length > 1 && (
              <Button
                type="text"
                danger
                size="small"
                icon={<CloseOutlined />}
                onClick={() => onRemove(index)}
              />
            )}
          </div>

          <div className="grid grid-cols-2 gap-3 mb-2">
            <div>
              <label className="block text-[11px] text-gray-400 mb-1">
                Batch No
              </label>
              <Input
                size="small"
                placeholder="e.g. BATCH-01"
                value={batch.batch_no}
                onChange={(e) => onUpdate(index, "batch_no", e.target.value)}
              />
            </div>
            <div>
              <label className="block text-[11px] text-gray-400 mb-1">
                Unit Cost (Rs.)
              </label>
              <InputNumber
                size="small"
                className="w-full"
                min={0}
                value={batch.cost_price}
                onChange={(val) => onUpdate(index, "cost_price", val || 0)}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-2">
            <div>
              <label className="block text-[11px] text-gray-400 mb-1">
                Initial Quantity
              </label>
              <InputNumber
                size="small"
                className="w-full"
                min={0}
                value={batch.quantity}
                onChange={(val) => onUpdate(index, "quantity", val || 0)}
              />
            </div>
            <div>
              <label className="block text-[11px] text-gray-400 mb-1">
                Expiry Date
              </label>
              <DatePicker
                size="small"
                className="w-full"
                placeholder="Optional"
                value={batch.expiry_date ? dayjs(batch.expiry_date) : null}
                onChange={(date) =>
                  onUpdate(
                    index,
                    "expiry_date",
                    date ? date.format("YYYY-MM-DD") : null,
                  )
                }
              />
            </div>
          </div>

          <Radio
            checked={batch.is_default === 1}
            onChange={() => onUpdate(index, "is_default", 1)}
          >
            <span className="text-xs text-gray-500">Set as default batch</span>
          </Radio>
        </div>
      ))}
    </div>
  </div>
);
